// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CybersecurityTrainingPage from './pages/CybersecurityTrainingPage.jsx';
import RedTeamPage from './pages/RedTeamPage.jsx';
import CTFVendorPage from './pages/CTFVendorPage.jsx';

const ScrollToTopAndRefreshAOS = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.AOS) {
            window.AOS.refresh();
        }
    }, [pathname]);
    return null;
};

const App = () => {
    return (
        <Router>
            <ScrollToTopAndRefreshAOS />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services/cybersecurity-training" element={<CybersecurityTrainingPage />} />
                <Route path="/services/red-team" element={<RedTeamPage />} />
                <Route path="/services/ctf-vendor" element={<CTFVendorPage />} />
            </Routes>
        </Router>
    );
};

export default App;
